import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { VfxDialogProps, SetVfxDialogProps } from "./vfxDialogProps";
import { UseDialogStyles } from "./styles";


export const Dialog: React.FC<VfxDialogProps> = (props) => {
    //SetVfxDialogProps(props);
    const dialogStyles = UseDialogStyles();
    const closeButtonClass: string = props.closeButtonClass ?? "secondary";
    const confirmButtonClass: string = props.confirmButtonClass ?? "primary";

    return (
        <Modal isOpen={props.open} toggle={props.onClose}>
            <div style={dialogStyles.confirmationContainer}>
                <div style={dialogStyles.flex}>
                    <ModalHeader style={dialogStyles.title}>
                        {props.contentTitle}
                        <Button
                            close
                            onClick={props.onClose}
                            style={dialogStyles.btnClose}
                        />
                    </ModalHeader>
                </div>

                <div style={dialogStyles.contentBox}>
                    <ModalBody style={dialogStyles.text}>
                        {props.contentText}
                        {props.children}
                    </ModalBody>
                </div>

                <ModalFooter>
                    {props.disabled ? (
                        <div>Loading...</div>
                    ) : (
                        <>
                            {!props.confirmOnly && (
                                    <Button color={closeButtonClass} onClick={props.onClose} style={props.closeButtonStyle}>
                                    {props.closeText}
                                </Button>
                            )}
                                <Button color={confirmButtonClass} onClick={props.onConfirm} disabled={props.disabled} style={props.confirmButtonStyle }>
                                {props.confirmText}
                            </Button>
                        </>
                    )}
                </ModalFooter>
            </div>
        </Modal>
    );
};